module.exports = __webpack_public_path__ + "img/bell-ringing-04.68bbdf7c.svg";